/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import classNames from "classnames/dedupe";
import React, { FC, ReactNode } from "react";
import { Product } from "../../../OrderInformation";
import { Typography } from "../../../Fundamentals/Typography";
import { TSearchResultItem } from "./SearchResults.interface";

export interface ISearchResultsItemProps {
  items?: TSearchResultItem<Product>[];
  searchTerm?: string;
  classes?: { root?: string };
  children?: ReactNode;
  onSearchResultClick?(item: TSearchResultItem<Product>);
}

const SearchResultsItem: FC<ISearchResultsItemProps> = ({
  items = [],
  searchTerm = "",
  classes = {},
  children,
  onSearchResultClick,
}) => (
  <ul>
    {items &&
      items.map((item) => {
        const clickHandler = () =>
          onSearchResultClick && onSearchResultClick(item);
        return (
          <li
            key={item.id}
            className={classNames("search-results-item", classes?.root, {
              selectable: item.selectable,
            })}
            onClick={clickHandler}
          >
            {children}
            {searchTerm ? (
              <>
                <Typography as="p">
                  <Typography variant="text-bold">{item.itemName}</Typography>
                  <Typography variant="text-regular"> {searchTerm}</Typography>
                </Typography>
                {item.count ? (
                  <Typography as="p">{item.count}</Typography>
                ) : null}
              </>
            ) : (
              <>
                <Typography as="p">{item.itemName}</Typography>
                {item.count ? (
                  <Typography as="p">{item.count}</Typography>
                ) : null}
              </>
            )}
          </li>
        );
      })}
  </ul>
);

export default SearchResultsItem;
